import { Component, OnInit } from '@angular/core';

const WOHistoryTabs: { id: number, label: string, route: string }[] = [
  { id: 1, label: 'lblActiveWo', route: 'activeWO' },
  { id: 2, label: 'lblHistoricalWo', route: 'historicalWO' }
]

@Component({
  selector: 'app-appointment-work-order-history',
  templateUrl: './appointment-work-order-history.component.html',
})
export class AppointmentWorkOrderHistoryComponent implements OnInit {
  tabs: { id: number, label: string, route: string }[] = WOHistoryTabs;
  selectedTabs: number = 1
  constructor() { 
     // This is intentional
  }

  ngOnInit(): void {
    // This is intentional
  }

}
